$(function() {
    var url = contextPath + '/my-portal';
    $('#my-portal-sidebar').load(url);
});